import { useState, useMemo } from 'react'

export const SORT_KEYS = {
  NEWEST: 'newest',
  CLOSING: 'closing',
  COLLECTION: 'collection',
  ACTIVE: 'active',
}

const sortEventsByOption = (events = [], sortKey) => {
  const clonedEvents = [...events]

  switch (sortKey) {
    case SORT_KEYS.CLOSING:
      return clonedEvents.sort(
        (a, b) => (Number(a.closingTimestamp) || 0) - (Number(b.closingTimestamp) || 0),
      )
    case SORT_KEYS.COLLECTION:
      return clonedEvents.sort(
        (a, b) => (Number(a.pickupTimestamp) || 0) - (Number(b.pickupTimestamp) || 0),
      )
    case SORT_KEYS.ACTIVE:
      return clonedEvents.sort(
        (a, b) => (Number(b.totalOrderCount) || 0) - (Number(a.totalOrderCount) || 0),
      )
    case SORT_KEYS.NEWEST:
    default:
      return clonedEvents.sort(
        (a, b) => (Number(b.createdAt) || 0) - (Number(a.createdAt) || 0),
      )
  }
}

const useShortEvent = (events = []) => {
  const [sortKey, setSortKey] = useState(SORT_KEYS.NEWEST)

  const handleSelectSort = (key) => {
    setSortKey(key)
  }

  const sortedEvents = useMemo(
    () => sortEventsByOption(events, sortKey),
    [events, sortKey],
  )

  return {
    sortKey,
    handleSelectSort,
    sortedEvents,
  }
}

export default useShortEvent
